import {
  TableConfig,
  UnknownQuestionHeaderSortMap,
  UnknownQuestionType,
  UnkownQuestionsTableHeaderTitles,
} from './types'
import { CSSProperties } from 'react'

const alightCenterStyles: CSSProperties = { width: '100%', justifyContent: 'center' }

export const unansweredQuestionsTableConfig: TableConfig<UnkownQuestionsTableHeaderTitles> = {
  question: { maxWidth: '25%', title: 'Question', paddingRight: 30 },
  answer: { maxWidth: '25%', title: 'Answer' },
  type: { maxWidth: '10%', title: 'Type', styles: alightCenterStyles },
  assignUser: { maxWidth: '12%', title: 'User', styles: alightCenterStyles },
  trainButton: { maxWidth: '10%', title: 'Train', styles: alightCenterStyles },
  trainedAt: { maxWidth: '10%', title: 'Trained At', styles: alightCenterStyles },
  createAt: { maxWidth: '10%', title: 'Created At', styles: alightCenterStyles },
  editButton: { maxWidth: '1.5%', title: '' },
  removeButton: { maxWidth: '1.5%', title: '' },
}

export const unansweredQuestionsTableTitles = Object.values(unansweredQuestionsTableConfig).map(
  ({ title, maxWidth, styles }) => ({ title, maxWidth, styles }),
)

export const unansweredQuestionTypeLabels: Record<UnknownQuestionType, string> = {
  [UnknownQuestionType.unknown]: 'Unknown',
  [UnknownQuestionType.faq]: 'FAQ',
  [UnknownQuestionType.beach]: 'BEACH',
  [UnknownQuestionType.bcp]: 'BCP',
}

export const unansweredQuestionsTypeDefaultOption = {
  value: UnknownQuestionType.unknown,
  label: unansweredQuestionTypeLabels.unknown,
} as any

export const unansweredQuestionTypeSearchOptions = Object.entries(unansweredQuestionTypeLabels).map(
  ([value, label]) => ({ value, label }),
)

export const unansweredQuestionTypeAssignOptions = Object.entries(unansweredQuestionTypeLabels)
  .filter(([value]) => value !== UnknownQuestionType.unknown)
  .map(([value, label]) => ({ value, label }))

export const unansweredQuestionsQueryParamNamesMap: Record<string, keyof UnknownQuestionHeaderSortMap> = {
  createdat: 'Created At',
  trainedAt: 'Trained At',
  user: 'User',
  train: 'Train',
  answer: 'Answer',
}
